//  获得一个唯一key
import _ from 'lodash'
const get = function(keyword = 'default') {
  return `${keyword}_${new Date().valueOf()}_${_.random(9999)}`  
}

export default {
  get
}
